import React from 'react';
import './ComponentCss/CompanyInfo.css'; // 스타일링을 위한 CSS 파일

const CompanyInfo = ({
                         번호,
                         기업이름,
                         대표자이름,
                         사용하는호실,
                         임대료,
                         부가세,
                         가스비,
                         전기세,
                         총납입액
                     }) => {
    return (
        <div className="company-info">
            <span className="company-info-item">{번호}</span>
            <span className="company-info-item">{기업이름}</span>
            <span className="company-info-item">{대표자이름}</span>
            <span className="company-info-item">{사용하는호실}</span>
            <span className="company-info-item">{임대료.toLocaleString()}원</span>
            <span className="company-info-item">{부가세.toLocaleString()}원</span>
            <span className="company-info-item">{가스비.toLocaleString()}원</span>
            <span className="company-info-item">{전기세.toLocaleString()}원</span>
            <span className="company-info-item">{총납입액.toLocaleString()}원</span>
        </div>
    );
};

export default CompanyInfo;
